import ReactMarkdown from 'react-markdown';
import styles from 'assets/styles/ai-chat-bot/markdownRenderer.module.css';
import { useEffect, useRef } from 'react';

interface ClassificationDataType {
    isClassification : string
}

const Classification = ({ isClassification }: ClassificationDataType) => {
    const classificationRef: any = useRef(null);

    useEffect(() =>  {
        if (classificationRef.current) {
            classificationRef.current.scrollTop = 0;
        }
    }, [isClassification])

    const MarkdownRenderer = ({ content }: any) => {
        return (
            <ReactMarkdown
                components={{
                    // Paragraphs
                    p: ({ children, ...props }) => {
                        const lines = children[0]?.toString()?.split('\n') || [];

                        let isFirstLine = true;
                        const transformedLines = lines.map((line) => {
                            const trimmedLine = line.trim();
                            const isDotPresent = trimmedLine.includes('•');
                            const hasTextBeforeDot = isDotPresent && trimmedLine.indexOf('•') > 0;

                            const shouldBreakLine = hasTextBeforeDot && !isFirstLine;

                            isFirstLine = false;
                            return shouldBreakLine ? '<br>•' + trimmedLine : line;
                        });

                        let transformedContent = transformedLines.join('<br>');
                        transformedContent = transformedContent.replace(/"([^"]*)"/g, '<b>$1</b>');
                        transformedContent = transformedContent.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
                        return (
                            <p
                                className={styles['markdown-paragraph'] }
                                style={{fontWeight : "400", fontSize : "12px"}}
                                dangerouslySetInnerHTML={{ __html: transformedContent }}
                                {...props}
                            />
                        );
                    },
                    //  Headings
                    h1: ({ node, ...props }) => (
                        <h1
                            className={styles['markdown-heading1']}
                            {...props}
                        />
                    ),
                    h2: ({ node, ...props }) => (
                        <h2
                            className={styles['markdown-heading2']}
                            {...props}
                        />
                    ),
                    h3: ({ node, ...props }) => (
                        <h3
                            className={styles['markdown-heading3']}
                            {...props}
                        />
                    ),
                    h4: ({ node, ...props }) => (
                        <h4
                            className={styles['markdown-heading4']}
                            {...props}
                        />
                    ),
                    h5: ({ node, ...props }) => (
                        <h5
                            className={styles['markdown-heading5']}
                            {...props}
                        />
                    ),
                    h6: ({ node, ...props }) => (
                        <h6
                            className={styles['markdown-heading6']}
                            {...props}
                        />
                    ),

                    // Lists
                    ul: ({ node, ...props }) => (
                        <ul
                            className={styles['markdown-unordered-list']}
                            style={{fontWeight : "400", fontSize : "12px" , paddingLeft: "15px"}}
                            {...props}
                        />
                    ),
                    ol: ({ node, ordered, ...props }) => (
                        <ol
                            className={styles['markdown-ordered-list']}
                            style={{fontWeight : "400", fontSize : "12px" , paddingLeft: "15px"}}
                            {...props}
                        />
                    ),

                    // List Items
                    li: ({ node, ordered, ...props }) => (
                        <li
                            className={styles['markdown-list-item']}
                            style={{fontWeight : "400", fontSize : "12px" ,  marginBottom: "1rem"}}
                            {...props}
                        />
                    ),

                    // Links
                    a: ({ node, ...props }: any) => (
                        <a
                            className={styles['markdown-link']}
                            href={node.href}
                            {...props}
                        >
                            {props.children}
                        </a>
                    ),
                    strong: ({ node, ...props }) => (
                        <strong
                            className={styles['markdown-bold']}
                            {...props}
                        />
                    ),
                    // Code Blocks styling or auto formatting API response...
                    pre: ({ node, ...props }) => (
                        <pre
                            className={styles['markdown-code-block']}
                            {...props}
                        />
                    ),
                    code: ({ inline, node, ...props }) => {
                        if (inline) {
                            return (
                                <code
                                    className={styles['markdown-inline-code']}
                                    {...props}
                                />
                            );
                        }
                        return (
                            //     <SyntaxHighlighter language="javascript" >
                            //     {props.children}
                            // </SyntaxHighlighter>

                            <p>{props.children}</p>
                        );
                    },

                    // Blockquotes
                    blockquote: ({ node, ...props }) => (
                        <blockquote
                            className={styles['markdown-blockquote']}
                            {...props}
                        />
                    ),

                    // Images
                    img: ({ node, ...props }: any) => (
                        <img
                            className={styles['markdown-image']}
                            src={node.src}
                            alt={node.alt}
                            {...props}
                        />
                    ),

                    // Table Headers
                    th: ({ node, ...props }) => (
                        <th
                            className={styles['markdown-table-header']}
                            {...props}
                        />
                    ),

                    // Table Cells
                    td: ({ node, ...props }) => (
                        <td
                            className={styles['markdown-table-cell']}
                            {...props}
                        />
                    ),

                    // Add other components and styles as needed
                }}
            >
                {content}
            </ReactMarkdown>
        );
    };
    return (
        <>
            <div className="card-body section-entities overflow-auto" ref={classificationRef}>
                <MarkdownRenderer content={isClassification} />
            </div>
        </>
    )
}

export default Classification